/** A photo answer's `text_fallback` is derived from its per-image `text_input`s — never print both. */
interface TextInputImage {
  text_input?: string;
}

const IMAGE_TEXT_SEPARATOR = '; ';

export const buildTextFallback = (images: readonly TextInputImage[]): string =>
  images
    .filter((img) => img.text_input && img.text_input.trim())
    .map((img, idx) => `Image ${idx + 1}: ${img.text_input!.trim()}`)
    .join(IMAGE_TEXT_SEPARATOR);

export const isDerivedTextFallback = (
  textFallback: string | undefined,
  images: readonly TextInputImage[]
): boolean => !!textFallback && textFallback === buildTextFallback(images);
